import { API } from '../../Config'
import { API_GET } from '../../Config'

export const GetDietCategory = () => {
  return (
    API_GET(API.getdietcategory)
  )
}


